module.exports = __webpack_public_path__ + "img/7.1ee05b9.png";